module.exports = __webpack_public_path__ + "img/betaskerlogo.28b9cdff.png";